import { Alert, Card, List, Stack, Text } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import { PageHeader } from "@/components/PageHeader";

/**
 * Operator-action audit is recorded server-side, not in this app. This screen explains
 * where it lives today and that a searchable audit log is on the way.
 */
export function AuditPage() {
  return (
    <>
      <PageHeader
        title="Audit log"
        subtitle="Every operator action is recorded securely on the server."
      />
      <Stack gap="lg">
        <Alert
          color="blue"
          variant="light"
          icon={<IconInfoCircle size={18} />}
          title="How operator actions are recorded"
        >
          <Text size="sm">
            When you take an action (revoke a key, change a role, expire a hold, …), the system
            records who did it, what changed, and when — against your account. That record is kept
            on the server, so nothing here can be tampered with from the browser.
          </Text>
        </Alert>

        <Card withBorder radius="md" padding="lg">
          <Text fw={600} mb="xs">
            Searchable audit log — coming soon
          </Text>
          <Text size="sm" c="dimmed" mb="sm">
            A single, searchable view of operator actions (who · what · when · result) is planned.
            Once it's available it'll show up here live, like every other screen.
          </Text>
          <List size="sm" spacing={4}>
            <List.Item>Today: each action is recorded against the operator who performed it.</List.Item>
            <List.Item>Next: a searchable operator-action history in this screen.</List.Item>
          </List>
        </Card>
      </Stack>
    </>
  );
}
